import { BasePool } from "../pool";
import type { ServiceContainer, ServiceProvider } from "../service-container";
import { BoxFactory } from "./BoxFactory";
import { CubicBCFactory } from "./CubicBCFactory";
import type { WeightingFunctionFactoriesPool } from "./WeightingFunctionFactoriesPool";
import { WeightingFunctionName } from "./WeightingFunctionName";

/**
 * Weighting function service provider.
 * @internal
 */
export const weightingFunctionProvider: ServiceProvider = {
  /**
   * Registers weighting function related entities.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    const pool: WeightingFunctionFactoriesPool = new BasePool();
    pool.add(WeightingFunctionName.BOX, new BoxFactory());
    pool.add(WeightingFunctionName.CUBIC_BC, new CubicBCFactory());
    container.register("WeightingFunctionFactoriesPool", pool);
  },
};
